<template>
  <v-row justify="center">
    <v-dialog v-model="show" max-width="400px" persistent>
      <v-card>
        <v-card-title style="word-break: normal !important; justify-content: center;">{{modalTitle}}</v-card-title>
        <v-card-text>
          <o-select-locations
            v-model="modifiedMaxAllocations.locations"
            :items='locations'
            :multiple='true'
            :label="$t('settings.locations').toUpperCase()"
            :outlined='true'
            :clearable='true'
          />
          <v-text-field
            class="ml-2 mr-2"
            :label="$t('settings.locationDailyMaxAllocations')"
            v-model="modifiedMaxAllocations.value"
            type="Number"
          ></v-text-field>
        </v-card-text>
        <v-card-actions class="pa-0">
          <v-btn
            color="primary"
            tile
            style="width: 50%"
            :disabled="!(Array.isArray(modifiedMaxAllocations.locations) && modifiedMaxAllocations.locations.length)"
            @click="confirm()"
          >{{$t('subOrder.confirm')}}</v-btn>
          <v-btn
            color="secondary"
            class="ml-0"
            style="width: 50%"
            tile
            @click="close()"
          >{{$t('subOrder.close')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>


<script>
  export default {
    name: "locationMaxAllocationsDialog",
    data() {
      return {
        modifiedMaxAllocations: JSON.parse(JSON.stringify(this.maxAllocations))
      }
    },
    props: {
      title: {
        type: String,
        default: undefined
      },
      introductionSentence: {
        type: String,
        default: undefined
      },
      value: {
        type: Boolean,
        default: false
      },
      locations: {
        type: Array,
        required: true,
      },
      maxAllocations: {
        type: Object,
        default(){
          return {
            activate: true,
            value: 1,
            locations: []
          }
        }
      }
    },
    computed: {
      show: {
        get() {
          return this.value;
        },
        set(value) {
          this.$emit("input", value);
        }
      },
      modalTitle: function(){
        if(!this.title){
          return this.$t("components.modalMultipleChoices.defaultTitle")
        }
        else return this.title
      },
    },
    methods: {
      confirm: function() {
        this.$emit("confirm", this.modifiedMaxAllocations)
        this.show = false
      },
      close(){
        this.$emit("close")
        this.show = false
      },
    }
  }
</script>
<style scoped>
</style>
